import { DatePipe } from '@angular/common';
import { inject, Injectable } from '@angular/core';
import { ConstructAPI } from 'src/app/API/constructAPI';
import { FileService } from './file.service';

@Injectable({
  providedIn: 'root'
})
export class MidMonthService {
  private datePipe = inject(DatePipe);
  private constructApi = inject(ConstructAPI);
  private fileService = inject(FileService);

  readonly defaultStartDate = 16;
  readonly defaultEndDate = 15;
  readonly noOfPreviousMonth = 6;

  //#region 'MidMonth Report'
  getMidMonth(compID: number, startDate: string, endDate: string, omitSchemeA: boolean, omitInfo: boolean, useVersion1 = false) {
    const url = useVersion1 ? this.constructApi.getMidMonthV1(compID, startDate, endDate, omitSchemeA, omitInfo) : this.constructApi.getMidMonth(compID, startDate, endDate, omitSchemeA, omitInfo);
    return this.fileService.getFileByUrl(url);
  }
  //#endregion

  //#region 'Extras Report'
  getExtrasReport(compID: number, startDate: string, endDate: string) {
    const url = this.constructApi.getExtrasReport(compID, startDate, endDate)
    return this.fileService.getFileByUrl(url);
  }
  //#endregion

  getmidMonthEndDateLocalStorageKey(): string {
    const compID = Number(sessionStorage.getItem("companyId"));
    return `${compID}-midMonthEndDate`;
  }

  getLastEndDateFromStorage(): Date {
    const s = localStorage.getItem(this.getmidMonthEndDateLocalStorageKey());
    return s ? new Date(s) : null;
  }

  isMidMonth(): boolean {
    return new Date().getDate() >= this.defaultEndDate;
  }

  getNextEndDate(isMidMonth: boolean, lastEndDate: Date): Date {
    let nextEndDate = new Date();
    if (lastEndDate) { // 2 Sep
      nextEndDate = new Date(lastEndDate);
      if (nextEndDate.getDate() < this.defaultEndDate) nextEndDate.setDate(this.defaultEndDate);
      else nextEndDate.setMonth(nextEndDate.getMonth() + 1, this.defaultEndDate);
    }
    else
      nextEndDate.setMonth(new Date().getMonth() - (isMidMonth ? 0 : 1), this.defaultEndDate);
    return nextEndDate;
  }

  saveMidMonthRange(startDate: Date, endDate: Date) {
    const isDefaultStart = (startDate.getDate() === this.defaultStartDate);
    const isDefaultEnd = (endDate.getDate() === this.defaultEndDate);
    const isDefaultRange = ((endDate.getMonth() - startDate.getMonth() === 1 && endDate.getFullYear() === startDate.getFullYear()) || (endDate.getMonth() - startDate.getMonth() === -11 && endDate.getFullYear() === startDate.getFullYear() + 1));
    const lastEndDate = this.getLastEndDateFromStorage();
    const isLatest = lastEndDate ? endDate > new Date(lastEndDate) : true;
    if (isDefaultStart && isDefaultEnd && isDefaultRange && isLatest)
      localStorage.setItem(this.getmidMonthEndDateLocalStorageKey(), endDate.toDateString());
  }

  getMidMonthLink(compID: string) {
    const today = new Date();
    const isMidMonth = this.isMidMonth();
    const lastEndDate = this.getLastEndDateFromStorage();
    const nextEndDate = this.getNextEndDate(isMidMonth, lastEndDate);
    const startDate = new Date(nextEndDate);
    startDate.setMonth(nextEndDate.getMonth() - 1, this.defaultStartDate);

    if ((isMidMonth && (!lastEndDate || today >= nextEndDate)) || (!isMidMonth && lastEndDate && today >= nextEndDate))
      return `midMonth/${compID}/${this.datePipe.transform(nextEndDate, 'yyyy-MM-dd')}`;
  }
}
